<template>
  <div
    @click.stop.prevent="toggleDropdown"
    @mouseover="hoverActive = true"
    @mouseout="hoverActive = false"
    :class="[
      'dropdown__new-list',
      { 'dropdown__new-list--active': dropdownActive }
    ]"
  >
    <!-- <button
      ref="dropdownMenu"
      class="btn btn--blue dropdownbut"
      :class="{ active: dropdownActive, 'w-100': fullWidth }"
      @click.stop.prevent="dropdownActive = !dropdownActive"
    >
      <slot name="dropdownMenuIcon">
        <icon width="25" name="DropDownList-icon1" />
      </slot>
      <span id="slot"><slot /></span>
    </button> -->
    <div class="three-select-schools__title" v-if="selectedItem">
      <div class="three-select-schools__title__info">
        <div class="scool-logo" v-if="selectedItem.avatar">
          <img
            v-if="selectedItem.avatar"
            :src="checkAvatar(selectedItem.avatar)"
            alt=""
          />
        </div>
        <span>{{ selectedItem.title }}</span>
      </div>
      <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M4.16797 7.5L10.0013 13.3333L15.8346 7.5"
          stroke="#8E9EBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="three-select-schools__title" v-if="!selectedItem">
      <!-- <div class="scool-logo" v-if="selectedItem.avatar">
        <img v-if="selectedItem.avatar" :src="selectedItem.avatar" alt="" />
      </div> -->
      <span>בחרו מוסד</span>
      <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M4.16797 7.5L10.0013 13.3333L15.8346 7.5"
          stroke="#8E9EBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div v-show="dropdownActive" class="dropdown__list__custom">
      <div class="filter-block" :class="{ active: active_filter }">
        <div class="filter-block__header">
          <h4 class="filter-block__title" style="color: #929baa">מסנן</h4>
          <button
            type="button"
            class="filter-block__clear-button"
            @click.stop="clear_filter"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3158 4H13.6842V7.5H20V11H4V7.5H10.3158V4Z"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 20H19V11H5V20Z"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M8.5 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.5 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.94727 20H17.0525"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            נקה הכל
          </button>
        </div>
        <div class="filter-block__body" @click.stop>
          <div class="form__field mb-2">
            <div class="form__field-label">רשות</div>
            <CustomThreeSelect
              v-model="filter.district_administration"
              :options="administration_select"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
          <div class="form__field mb-2">
            <div class="form__field-label">סוג המסגרת</div>
            <CustomThreeSelect
              v-model="filter.institution_type"
              :options="inst_types"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
          <div class="form__field mb-2">
            <div class="form__field-label">יישוב</div>
            <CustomThreeSelect
              v-model="filter.city"
              :options="regions"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
        </div>
        <button
          type="button"
          class="btn btn--blue btn--full"
          @click.stop="filtered"
        >
          חפש
        </button>
      </div>
      <div style="position: relative">
        <div class="search">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
              stroke="#929BAA"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 20L16 16"
              stroke="#929BAA"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <input
            v-model="search"
            :disabled="active_filter"
            type="text"
            :class="{ 'disabled__search-filter': active_filter }"
            class="custom__search"
            placeholder="הזן את השם"
            ref="searchInput"
            @click.stop
            @keydown.enter.prevent
          />
          <button
            type="button"
            class="filter-button"
            @click.stop="active_filter = !active_filter"
          >
            <img v-if="filters_active" src="/images/filter-active.svg" />
            <img
              v-if="active_filter && !filters_active"
              src="/images/filter-open.svg"
            />

            <svg
              v-if="!filters_active && !active_filter"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6H4L10.4 13.3578V18.4444L13.6 20V13.3578L20 6Z"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        <div class="sort-header">
          <!-- <div class="sort-header__label" v-if="objAllItem.length">
            סה״כ <b>{{ totalStudents }}</b>
          </div> -->
          <!-- <label
            for=""
            class="checkbox-all dropdown-list__user"
            :class="{ active: selectedAllUsers }"
            @click.stop="selectedAll"
          >
            <div class="dropdown-list__user-checkbox"></div>
            <div class="checkbox-all__text">
              ({{ selectedStudents.length }} נבחרו)
            </div>
            <span class="dropdown-list__user-checkbox active"></span>
          </label> -->
        </div>
      </div>
      <!-- <div v-if="objAllItem.length === 0" class="custom__search__drop drop">
        לא נמצאו תוצאות
      </div> -->
      <ul
        class="dropdown-list__users"
        :style="{ maxHeight: max_height + 'px' + ' ' + '!important' }"
      >
        <li
          v-for="item in objAllItem"
          :key="item.id"
          class="dropdown-list__user"
          :class="{
            'selected-item': selectedItem && selectedItem.id === item.id
          }"
          @click.prevent.stop="selectItem(item, item.id)"
        >
          <div class="dropdown-list__user-ava">
            <img v-avatar-placeholder :src="checkAvatar(item.avatar)" alt="" />
          </div>
          <div class="dropdown-list__user-content">
            <div class="dropdown-list__user-title">
              <span
                :class="{
                  'selected-item-title':
                    selectedItem && selectedItem.id === item.id
                }"
                >{{ item.title }}</span
              >
              <!-- <span>{{ selectItems(item.user) }}</span> -->
            </div>
            <div
              v-if="item.district_administration"
              class="dropdown-list__user-subtitle"
              :class="{
                'selected-item-title':
                  selectedItem && selectedItem.id === item.id
              }"
            >
              {{
                item.district_administration
                  ? item.district_administration.title
                  : ''
              }}
              <!-- |
              <b dir="ltr">
                {{ item.user.class_name ? item.user.class_name : '-' }}</b
              > -->
            </div>
          </div>

          <!-- <div
            v-if="!withoutCheckbox"
            class="dropdown-list__user-checkbox"
          ></div> -->
        </li>
        <PaginationButton
          v-if="last_page > pageList && viewPagination"
          :countUsers="totalCount"
          :view-count="viewCount"
          @clickPagination="clickPagination"
        ></PaginationButton>
      </ul>
    </div>
    <!-- <div
        class="
          form__field-select-mupltiple form__field-select-wrap
          dropdown__list
        "
        :class="{
          for_inherit: for_inherit,
          for_inherit_vertical: for_inherit_vertical
        }"
      >
        <div
              v-show="dropdownActive"
              class="add__rows"
              :class="{ vert: vertical }"
            ></div>
      </div> -->
  </div>
</template>
<script>
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';
import { myPlaginDebounce } from '@/Plugins/helper';
import PaginationButton from '../Buttons/PaginationButton.vue';
export default {
  components: {
    CustomThreeSelect,
    PaginationButton
  },
  props: {
    inst_types: Array,
    administration_select: Array,
    objAllItem: Array,
    fullWidth: Boolean,
    regions: Array,

    max_height: {
      type: [Number, String]
    },
    viewPagination: {
      type: Boolean,
      default: false
    },
    last_page: {
      type: Number
    },
    pageList: {
      type: Number
    },
    viewCount: {
      type: Number
    },
    totalCount: {
      type: Number
    },
    selectedInst: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      filter: {
        district_administration: [],
        institution_type: [],
        city: []
      },
      active_filter: false,
      search: '',
      dropdownActive: false,
      filters_active: false,
      selectedItem: null,
      hoverActive: false
    };
  },
  watch: {
    // search(val) {
    //   console.log(val);
    //   this.$emit('search', val);
    // },
    search: myPlaginDebounce(function (newVal) {
      this.$emit('search', newVal);
    }, 300),
    selectedInst: {
      immediate: true,
      handler(val) {
        if (val && val.id != null && val.id !== '') {
          this.selectedItem = val;
        } else {
          this.selectedItem = null;
        }
      }
    }
  },
  mounted() {
    console.log('tyt');
    document.addEventListener('click', this.handleClickOutside);
    // if (!localStorage.getItem('selectedInst')) {
    //   this.selectedItem = this.objAllItem[0];
    //   console.log(this.selectedItem);
    // } else {
    //   const id = JSON.parse(localStorage.getItem('selectedInst'));
    //   const inst = this.objAllItem.findItem(item => item.id === id);
    //   console.log(inst);
    //   if (inst) {
    //     this.selectedItem = inst;
    //   }
    // }
  },
  methods: {
    checkAvatar(avatar) {
      if (avatar) {
        return avatar;
      } else {
        return '/images/cover.jpg';
      }
    },
    clickPagination() {
      this.$emit('clickPagination');
    },
    filtered() {
      this.$emit('filtered', this.filter);
      this.active_filter = false;
    },
    clear_filter() {
      this.search = '';
      this.filter = {
        district_administration: [],
        institution_type: [],
        city: []
      };
    },
    selectItem(item, id) {
      this.selectedItem = item;
      this.$emit('select', id, item);
      this.dropdownActive = false;
    },
    toggleDropdown() {
      this.dropdownActive = !this.dropdownActive;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target) && !this.active_filter) {
        this.dropdownActive = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.three-select-schools__title__info {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}
.dropdown-list__users {
  max-height: 460px;
}
.selected-item {
  background-color: #eef7ff;
}
.selected-item-title {
  color: #409fff;
}
.form__field-label {
  margin-bottom: 8px;
}
.filter-block__body .form__field:last-child {
  margin-bottom: 16px !important;
}
.dropdown__new-list {
  transition: background-color 0.6s ease, color 0.6s ease;
}
.dropdown__new-list:hover {
  background-color: #eef7ff !important;
  color: #409fff;
}
.dropdown__new-list--active {
  background-color: #eef7ff;
  color: #0077ef !important;
}
.new-list.hovered path {
  transition: stroke 0.6s ease;
}
.new-list.hovered path {
  stroke: #409fff;
}
.new-list--active {
  transform: rotate(180deg);
}
.new-list--active path {
  stroke: #0077ef !important;
}
.dropdown__list__custom {
  width: 360px;
}
.three-select-schools__title {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
  font-size: 24px;
  font-weight: 600;

  .scool-logo {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      display: flex;
    }
  }
}
.disabled__search-filter {
  background: #ebeef5;
  cursor: not-allowed;
}
.dropdown__new-list {
  position: relative;
}

.dropdown__list__custom {
  z-index: 11;
  right: 0;
  top: 32px;
}

.checkbox-all__text {
  margin-left: 30px;
}
.dropdown-list {
  &__user {
    padding: 8px;
    text-decoration: none;
  }
}
.expired_delay {
  background-color: #ffe8e6;
}
.active_use {
  background: #e5f2ff;
}
.active_green {
  background: #e6ffea;
}
.status__image {
  position: relative;
  left: 26px;
}

.filter-block {
  position: absolute;
  top: 58px;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 262px;
  background-color: #fff;
  padding: 12px 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;
  box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
    0px 4px 12px -2px rgba(56, 69, 93, 0.12);
  &.active {
    opacity: 1;
    pointer-events: all;
  }
  &__close-button {
    display: flex;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    margin-bottom: 8px;
    cursor: pointer;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  &__clear-button {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    border: none;
    background-color: transparent;
    padding: 8px 4px;
  }
  &__body {
    margin-bottom: auto;
  }
}

.search {
  position: relative;
  border: 1px solid #cfd3de;
  border-radius: 4px;
  margin: 8px;

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 8px;
  }
  input {
    border-radius: 4px;
    padding-right: 40px;
    &::placeholder {
      color: #cfd3de;
    }
  }
}

.filter-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  border-right: 1px solid #cfd3de;
  cursor: pointer;
}
.sort-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 8px 0 8px;
  &__label {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    b {
      font-weight: 500;
    }
  }
}

.checkbox-all {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  &__input {
    display: none;
    &:checked {
      .checkbox-all {
        &__marker {
          border-color: #7fbfff;
          background-color: #7fbfff;
        }
      }
    }
  }
  &__marker {
    width: 16px;
    height: 16px;
    border: 1px solid #cfd3de;
    border-radius: 2px;
    position: relative;
    flex-shrink: 0;
    transition: 0.3s;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(/images/tire-icon.svg);
      background-position: center;
      background-size: contain;
    }
  }
  &__text {
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #7fbfff;
  }
}

@media (max-width: 767px) {
  .three-select-schools__title {
    font-size: 28px;
  }
}

@media (max-width: 470px) {
  .three-select-schools__title {
    font-size: 24px;
  }
}
</style>
